import img1 from '../../downloads/img/heroes-section/img1.webp';
import img2 from '../../downloads/img/heroes-section/img2.webp';
import img3 from '../../downloads/img/heroes-section/img3.webp';
import img4 from '../../downloads/img/heroes-section/img4.webp';
import img5 from '../../downloads/img/heroes-section/img5.webp';
import img6 from '../../downloads/img/heroes-section/img6.webp';
import img7 from '../../downloads/img/heroes-section/img7.webp';
import img8 from '../../downloads/img/heroes-section/img8.webp';
import img9 from '../../downloads/img/heroes-section/img9.webp';
import img10 from '../../downloads/img/heroes-section/img10.webp';

let heroesSectionObj = [
    {
        id:7,
        name:'img1.webp',
        link: img1
    },
    {
        id:8,
        name:'img2.webp',
        link: img2
    },
    {
        id:9,
        name:'img10.webp',
        link: img10
    },
    {
        id:10,
        name:'img3.webp',
        link: img3
    },
    {
        id:11,
        name:'img4.webp',
        link: img4
    },
    {
        id:12,
        name:'img5.webp',
        link: img5
    },
    {
        id:13,
        name:'img6.webp',
        link: img6
    },
    {
        id:14,
        name:'img7.webp',
        link: img7
    },
    {
        id:15,
        name:'img8.webp',
        link: img8
    },
    {
        id:16,
        name:'img9.webp',
        link: img9
    },
]

export { img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, heroesSectionObj};